const testimonials = [
  {
    "id": 1,
    "name": "Ruby Coote",
    "position": "Series Editor",
    "quote": "\"Alex is a great asset for any video project, not only is he a great editor but he also has a really great editorial eye and knows how to build stories and create narratives without editorial support. He helped us develop and script a brand new gaming show with little or no supervision and he also brings a lot of positivity to any team with his friendly, can-do attitude.\""
  },
  {
    "id": 2,
    "name": "Chris Longo",
    "position": "Director of Editorial and Partnerships",
    "quote": "\"I’ve worked with Alex for years on various productions, and he’s always been a joy to have around. He is skilled with a camera and as a post production professional, and brings great attention to detail to everything  he does. He also has a keen eye for innovation and offers great professional perspectives and outside-the-box thinking.\""
  },
  {
    "id": 3,
    "name": "Jack Gould",
    "position": "Creative Director",
    "quote": "\"Alex is talented, smart, efficient and capable of working across a number of different professional responsibilities. He makes for a great member of any production team.\""
  }
];

export default testimonials;